import { render, staticRenderFns } from "./MemberBenefits.vue?vue&type=template&id=522bdbf4"
import script from "./MemberBenefits.vue?vue&type=script&lang=js"
export * from "./MemberBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports